export default __webpack_public_path__ + "static/media/cx.fb3742cd.jpg";